import type { TableColumnsDto } from 'cadenza/base-table/model/table-columns-dto';
import type { ConditionType } from 'cadenza/model/condition-type.gen';
import type { Objecttype } from 'cadenza/workbook/api/objecttype';
import type { WorkbookAttributeDto } from 'cadenza/workbook/api/workbook-attribute-dto';
import type { AttributeId } from 'cadenza/workbook/model/attribute-id.gen';
import type { ConditionDto, WorkbookQlConditionValueItemDto } from 'cadenza/workbook/model/condition-dto';

const CONDITION_TYPES_CONVERTIBLE_TO_QL = [
  'TableCondition',
  'DateCondition',
  'ValueIntervalCondition',
  'DateIntervalCondition',
];

/**
 * Returns complete condition value.
 */
export function getQlConditionValue(condition: Pick<ConditionDto, 'values'>) {
  return condition?.values?.valueItems[0] as WorkbookQlConditionValueItemDto;
}

export function getQlConditionVariables(condition?: Pick<ConditionDto, 'values'>) {
  return (condition && getQlConditionValue(condition)?.variables) ?? [];
}

export function getQlVariable(condition?: ConditionDto) {
  return getQlConditionVariables(condition)?.[0];
}

export function isConditionTypeConvertibleToQl(conditionType: ConditionType) {
  return CONDITION_TYPES_CONVERTIBLE_TO_QL.includes(conditionType);
}

/**
 * Checks if every column is visible, has an attributeType other than 'IPADDRESS'
 * and checks if its name occurs in acceptedAttributes (id check would be an improvement).
 */
export function areConditionTableColumnsAccepted(tableColumnsDefinitionDto?: TableColumnsDto) {
  return (
    tableColumnsDefinitionDto?.columns.every((column) => {
      return column.attributeType !== 'IPADDRESS';
    }) ?? false
  ); // In case tableColumnsDefinitionDto is undefined
}

export function isAttributeRelationalNameAttribute(objecttype: Objecttype, attributeId: AttributeId) {
  return objecttype.attributeRelationGroups.some((relation) => relation.nameAttribute === attributeId);
}

export function areConditionAttributeIdsAccepted(
  acceptedAttributes: WorkbookAttributeDto[],
  ...attributeIds: (AttributeId | undefined)[]
) {
  return attributeIds.every((attributeId) =>
    acceptedAttributes.some((acceptedAttribute) => attributeId === acceptedAttribute.id),
  );
}
